<template>
    <div class="full-container service">
        <apj-page-banner :options="options"></apj-page-banner>
        <div class="full-container">
          <div class=" pi-justify-center border">
          <el-menu
            class="aboutus-menus pi-align-center pi-justify-between"
            :default-active="$route.path"
            style="width:1140px"
            mode="horizontal"
            router
            >

              <el-menu-item
              v-for="(item, index) in menuList"
              :key="'menu' + index"
              :index="item.path"
              class=" pi-fz-16"
              >
              {{item.name}}
            </el-menu-item>

          </el-menu>
          </div>
          <transition name="el-fade-in-linear">
            <router-view></router-view>
          </transition>
        </div>
        <!-- <apj-page-contact></apj-page-contact> -->
    </div>
</template>

<script>
import ApjPageContact from '../../components/apj-page-contact'
import ApjPageBanner from '../../components/apj-page-banner'
export default {
  name: "product",
  components: {
    ApjPageContact,
    ApjPageBanner,
  },
  data() {
    return {
      options: {
        banner: require("@/assets/images/banner/about_us.png"),
        title: "粤港澳大湾区领先的数字化转型服务提供商",
        text:''
        // text: "以客户需求为中心，提供独特竞争优势的数字化服务"
      },
      activeIndex: '/aboutus/overview',
      menuList: [
        {
          name: '公司概况',
          path: '/aboutus/overview'
        }, {
          name: '发展历程',
          path: '/aboutus/history'
        }, {
          name: '资质荣誉',
          path: '/aboutus/honor'
        }, {
          name: '加入我们',
          path: '/aboutus/join'
        }, {
          name: '新闻资讯',
          path: '/aboutus/news'
        }
      ],
      // banner: require('@/assets/images/banner/service.jpg'),
      msg: "Welcome to Your Vue.js App",
    };
  },
  mounted() {
    // 进入页面时，菜单是否透明，或不显示阴影，默认为false，这里是示例
    globalEvent.$emit('changeHeaderTransparent', {
      isTransparent: true,
      isNoShadow: false
    })
    globalEvent.$emit('changeMenu', 4)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/theme.scss';

div {
  width: 100%;
}
.border{
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.1);
}
/** page style */
.aboutus-menus {
  border:none;
  // width: 100%;
  display: flex;
  // justify-content: space-between;
  align-items: center;
}
.introduce-container {
  max-width: 1140px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutus/index.vue